import * as Bixby from './../../core';

export interface CloState {
  isLoading: boolean;
  error?: Bixby.Models.BixbyError;
  currentClo?: Bixby.Models.Clo;
  heatMapActive: boolean;
  clos?: Bixby.Models.CloSlim[];
  isAddingCloToClient: boolean;
  isDeletingCloFromClient?: boolean;
  deletingCloFromClientError?: Bixby.Models.BixbyError;
}

export const CLO_LOADING = 'CLO_LOADING';
export const CLO_SUCCESS = 'CLO_SUCCESS';
export const ALL_CLO_SUCCESS = 'ALL_CLO_SUCCESS';
export const CLO_FAILURE = 'CLO_FAILURE';
export const HEATMAP_ON = 'HEATMAP_ON';
export const HEATMAP_OFF = 'HEATMAP_OFF';
export const CREATE_CLO = 'CREATE_CLO';
export const ADD_CLIENT_CLO = 'ADD_CLIENT_CLO';
export const ADD_CLIENT_CLO_SUCCESS = 'ADD_CLIENT_CLO_SUCCESS';
export const ADD_CLIENT_CLO_FAILURE = 'ADD_CLIENT_CLO_FAILURE';
export const DELETE_CLIENT_CLO= 'DELETE_CLIENT_CLO';
export const DELETE_CLIENT_CLO_SUCCESS = 'DELETE_CLIENT_CLO_SUCCESS';
export const DELETE_CLIENT_CLO_FAILURE = 'DELETE_CLIENT_CLO_FAILURE';

interface CloLoading extends Bixby.Models.BixbyAction<undefined, typeof CLO_LOADING> {
  type: typeof CLO_LOADING;
}

interface CloSuccess extends Bixby.Models.BixbyAction<Bixby.Models.Clo, typeof CLO_SUCCESS> {
  type: typeof CLO_SUCCESS;
  payload: Bixby.Models.Clo;
}

interface AllClosSuccess extends Bixby.Models.BixbyAction<Bixby.Models.CloSlim[], typeof ALL_CLO_SUCCESS> {
  type: typeof ALL_CLO_SUCCESS;
  payload: Bixby.Models.CloSlim[];
}

interface CloFailure extends Bixby.Models.BixbyAction<Bixby.Models.BixbyError, typeof CLO_FAILURE> {
  type: typeof CLO_FAILURE;
  payload: Bixby.Models.BixbyError;
}

interface HeatMapOn extends Bixby.Models.BixbyAction<boolean, typeof HEATMAP_ON> {
  type: typeof HEATMAP_ON;
  payload: true;
}

interface HeatMapOff extends Bixby.Models.BixbyAction<boolean, typeof HEATMAP_OFF> {
  type: typeof HEATMAP_OFF;
  payload: false;
}

interface CreateClo extends Bixby.Models.BixbyAction<Bixby.Models.Clo, typeof CREATE_CLO> {
  type: typeof CREATE_CLO;
  payload: Bixby.Models.Clo;
}

interface AddClientClo extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO> {
  type: typeof ADD_CLIENT_CLO;
}

interface AddClientCloSuccess extends Bixby.Models.BixbyAction<boolean, typeof ADD_CLIENT_CLO_SUCCESS> {
  type: typeof ADD_CLIENT_CLO_SUCCESS;
  payload: boolean;
}

interface AddClientCloFailure extends Bixby.Models.BixbyAction<undefined, typeof ADD_CLIENT_CLO_FAILURE> {
  type: typeof ADD_CLIENT_CLO_FAILURE;
}

interface DeleteClientClo extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO> {
  type: typeof DELETE_CLIENT_CLO;
}

interface DeleteClientCloSuccess extends Bixby.Models.BixbyAction<boolean, typeof DELETE_CLIENT_CLO_SUCCESS> {
  type: typeof DELETE_CLIENT_CLO_SUCCESS;
  payload: boolean;
}

interface DeleteClientCloFailure extends Bixby.Models.BixbyAction<undefined, typeof DELETE_CLIENT_CLO_FAILURE> {
  type: typeof DELETE_CLIENT_CLO_FAILURE;
}

export type CloActionTypes =
  | CloLoading
  | CloFailure
  | CloSuccess
  | HeatMapOff
  | HeatMapOn
  | AllClosSuccess
  | CreateClo
  | AddClientClo
  | AddClientCloSuccess
  | AddClientCloFailure
  | DeleteClientClo
  | DeleteClientCloSuccess
  | DeleteClientCloFailure;
